<mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="itemSearchRequest.IsAdvancedSearch ? 1 : 0">
    <br />
    <mat-tab label="Basic Search">
        <br />
        <app-text-search-field [label]="'Basic Search Term'" [placeholder]="'Search both First and Last Name'" [textSearchPattern]="itemSearchRequest.BasicSearchString"></app-text-search-field>
        <br />
    </mat-tab>
    <mat-tab #advancedSearchTab label="Advanced Search">
        <br />
        <app-text-search-field [label]="firstNameLabel" [placeholder]="firstNamePlaceholder" [textSearchPattern]="itemSearchRequest.FirstName"></app-text-search-field>
        <br />
        <app-text-search-field [label]="lastNameLabel" [placeholder]="lastNamePlaceholder" [textSearchPattern]="itemSearchRequest.LastName"></app-text-search-field>
    </mat-tab>
</mat-tab-group>
<br />
<mat-form-field appearance="outline" style="width: 100%;display:none;">
    <input matInput value="xxx" style="display: none;" />
    <mat-label>Search Feed</mat-label>
    <div class="appfeed-pane {{this.appFeedPaneDynamicClassName}}">
        <app-app-feed [dataSource]="appFeedMessages"></app-app-feed>
    </div>
</mat-form-field>
<br />
<button mat-button #saveButton (click)="save()">
    <mat-icon class="material-symbols-outlined">
        save
    </mat-icon>
    {{ saveButtonCaption }}
</button>
<button [disabled]="!isPendingChanges" mat-button (click)="undo()">
    <mat-icon class="material-symbols-outlined">
        undo
    </mat-icon>
    UNDO CHANGES
</button>
<button [disabled]="this.itemEnvelope!.Document!.Item.SearchRequestId <= 0" mat-button (click)="delete()">
    <mat-icon class="material-symbols-outlined">
        delete_forever
    </mat-icon>
    DELETE THIS SEARCH REQUEST
</button>
